import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
import withUserInfo from '../../containers/apollo/withUserInfo';
import withLocaleRedirect from '../../containers/withLocaleRedirect';
import { ExploreForYou } from './ExploreForYou';

export default compose(
  injectIntl,
  withUserInfo,
  withLocaleRedirect
)(ExploreForYou);
